export default "/images/vendor/flag-icons/flags/4x3/es-pv.svg?bc671336343cce95f7941645285b8282";